import React from 'react';
import style from './Users.module.css';
import User from "./User";



const Users = (props) => {
    let userItem = props.users.map(user => <User  id = {user.id} foto = {user.avatar}
                                                  name = {user.name} since = {user.since}
                                                  followed ={user.followed} key = {user.id}
                                                  unfollowUser ={props.unfollowUser}
                                                  followUser = {props.followUser}/>)
    return (
        <div className={style.users}>
            {userItem}
        </div>
    );
};

export default Users;